import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "modal-container show" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "blocker" }, null, -1)
const _hoisted_3 = {
  class: "modal",
  style: {"width":"500px"}
}
const _hoisted_4 = { class: "modal__header" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h3", { class: "modal__header--title" }, "Lead Details", -1)
const _hoisted_6 = { class: "modal__content pa-2" }
const _hoisted_7 = {
  key: 0,
  class: "table"
}
const _hoisted_8 = { class: "text--align-left" }
const _hoisted_9 = { class: "text--align-left" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("a", {
          class: "fa fa-times modal__header--clear",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
        })
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_ctx.response)
          ? (_openBlock(), _createElementBlock("table", _hoisted_7, [
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.response, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", _hoisted_8, _toDisplayString(item.fieldName), 1),
                    _createElementVNode("td", _hoisted_9, _toDisplayString(item.fieldValue), 1)
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}